import { useMemo } from "react";
import { useMsal } from "@azure/msal-react";

import UserRoleContext from "./UserRoleContext";
import { useGetAvtorizacije } from "../services/Authorisation/authorisationAPI";

const toArray = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

const UserRoleProvider = ({ children }) => {
  const { accounts } = useMsal();
  const username = accounts[0]?.username;

  const { data: avtorizacije, isLoading: isLoadingUserRole } =
    useGetAvtorizacije(username);

  const userRole = useMemo(() => {
    if (!avtorizacije || avtorizacije === 0) return null;

    return {
      clanica: avtorizacije.clanica ?? null,
      clanicaID: avtorizacije.clanicaID ?? null,
      moduli: {
        avtorizacije: avtorizacije.moduli.avtorizacije,
        revizijskaSled: avtorizacije.moduli.revizijskaSled,
        programi: avtorizacije.moduli.programi,
        razpisi: avtorizacije.moduli.razpisi,
        aktualniRazpisi: avtorizacije.moduli.aktualniRazpisi,
        projekti: avtorizacije.moduli.projekti,
        partnerji: avtorizacije.moduli.partnerji,
        deminimis:
          avtorizacije.moduli.deminimis ?? avtorizacije.moduli.Deminimis,
        izpisi: avtorizacije.moduli.izpisi,
        izpisiClanice: avtorizacije.moduli.izpisiClanice,
        sifranti: avtorizacije.moduli.sifranti,
      },
    };
  }, [avtorizacije]);

  return (
    <UserRoleContext.Provider value={{ userRole, isLoadingUserRole }}>
      {children}
    </UserRoleContext.Provider>
  );
};

export default UserRoleProvider;
